import { render, staticRenderFns } from "./ion-button.vue?vue&type=template&id=0d60f46b"
import script from "./ion-button.vue?vue&type=script&lang=js"
export * from "./ion-button.vue?vue&type=script&lang=js"
import style0 from "./ion-button.vue?vue&type=style&index=0&id=0d60f46b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports